module.exports = __webpack_public_path__ + "img/vehicleAll.d150e222.png";